import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

function appendSize(obj, type, size, offset, push, pull) {
    if (size) {
        obj[`col-${type}-${size}`] = true;
    }
    if (offset) {
        obj[`offset-${type}-${offset}`] = true;
    }
    if (push) {
        obj[`push-${type}-${push}`] = true;
    }
    if (pull) {
        obj[`pull-${type}-${pull}`] = true;
    }
}
const Column = function Column({ children, className, lg, lgOffset, lgPull, lgPush, md, mdOffset, mdPull, mdPush, xl, xlPull, xlPush, xlOffset, xs, xsOffset, xsPush, xsPull, }) {
    const obj = {};
    appendSize(obj, 'xs', xs, xsOffset, xsPush, xsPull);
    appendSize(obj, 'md', md, mdOffset, mdPush, mdPull);
    appendSize(obj, 'lg', lg, lgOffset, lgPush, lgPull);
    appendSize(obj, 'xl', xl, xlOffset, xlPush, xlPull);
    const classes = cns(obj, className);
    return (jsx("div", { className: classes, children: children }));
};
Column.defaultProps = {
    children: null,
    className: '',
    lg: null,
    lgOffset: null,
    lgPull: null,
    lgPush: null,
    md: null,
    mdOffset: null,
    mdPull: null,
    mdPush: null,
    xl: null,
    xlOffset: null,
    xlPull: null,
    xlPush: null,
    xs: null,
    xsOffset: null,
    xsPull: null,
    xsPush: null,
};

export { Column as default };
